import React from 'react';
import { TopNavigation, TopNavigationItemIcon } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/dist/tokens';
import styled from '@emotion/styled';

import { web_max_width } from '@common/styles';

import { useCartItemsCountQuery } from '../../hooks/queries/useCartItemsCountQuery';

export const HEADER_HEIGHT = 44;

interface Props {
  main_domain: string;
  show_search_button?: boolean;
  show_home_button?: boolean;
  is_transparent_header?: boolean;
  is_solid_state?: boolean;
  baddge_background_color?: string;
  title?: string;
}

export const StoreHomeHeader: React.FC<React.PropsWithChildren<Props>> = ({
  main_domain,
  show_search_button = true,
  show_home_button = true,
  is_transparent_header,
  is_solid_state,
  baddge_background_color,
  title,
}) => {
  const { data: cart_items_count } = useCartItemsCountQuery({ refetchOnWindowFocus: 'always' });

  return (
    <HeaderWrapper
      className={`${is_transparent_header ? 'transparent-header' : ''} ${is_transparent_header && !is_solid_state ? 'transparent' : ''}`}
    >
      <TopNavigation.DetailsBasic
        title={title}
        style={{
          backgroundColor: is_transparent_header && !is_solid_state ? 'transparent' : vars.color.backgroundSurface,
        }}
        transparent={is_transparent_header && !is_solid_state}
      >
        <HeaderRightButtons>
          {show_home_button && <TopNavigationItemIcon.HomeIcon href='/' />}
          {show_search_button && <TopNavigationItemIcon.SearchIcon href={`/${main_domain}/search`} />}
          <TopNavigationItemIcon.CartIcon
            href='/cart'
            count={cart_items_count}
            badgeBackgroundColor={baddge_background_color}
          />
        </HeaderRightButtons>
      </TopNavigation.DetailsBasic>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  position: sticky;
  top: 0;
  width: 100%;
  max-width: ${web_max_width}px;
  z-index: 205;

  &.transparent-header {
    position: fixed;
  }
`;

const HeaderRightButtons = styled.span`
  display: flex;
  align-items: center;

  .transparent & {
    & svg {
      color: #fff;
    }
  }
`;
